import { FC, useState, useContext, useMemo } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { CreateCampaignContext, STEP, StepDirection } from '~/contexts/CreateCampaignContext'
import { colorPalette } from '~/constants/styles/colors'
import { FIRST_STEP, LAST_STEP, ExpenseInfoDialogSteps, TOTAL_STEPS } from './Steps'

type Props = {
  isOpen: boolean
  setOpen: (open: boolean) => void
}

export const ExpenseInfoDialog: FC<Props> = ({ isOpen, setOpen }) => {
  const { changePageStep, handleSkipExpenseInfoDialog } = useContext(CreateCampaignContext)
  const [step, setStep] = useState<number>(FIRST_STEP)
  const [shouldHideDialog, setShouldHideDialog] = useState(false)

  const isFirstStep = step === FIRST_STEP
  const isLastStep = useMemo(() => step === LAST_STEP, [step])

  const handleStepChange = (direction: StepDirection) => {
    setStep((prev) => (direction === STEP.NEXT ? Math.min(prev + 1, LAST_STEP) : Math.max(prev - 1, FIRST_STEP)))
  }

  const closeDialog = () => {
    setOpen(false)
    setStep(FIRST_STEP)
  }

  const handleUnderstand = () => {
    handleSkipExpenseInfoDialog(shouldHideDialog)
    closeDialog()
  }

  const handleCloseDialog = () => {
    changePageStep(STEP.PREV)
    closeDialog()
  }

  const currentStep = ExpenseInfoDialogSteps[step]

  if (!currentStep) {
    return (
      <Dialog open={isOpen} maxWidth="md" fullWidth>
        <DialogContent>
          <Typography>
            表示に必要な情報が取得できませんでした。お手数ですが、時間をおいて再度お試しください。
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleCloseDialog}>
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <Dialog open={isOpen} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography color={colorPalette.primary.main} variant="labelMEnNormal" fontWeight="bold">
          説明: {step + 1}/{TOTAL_STEPS}
        </Typography>
        <Typography fontWeight="bold">{currentStep.title}</Typography>
      </DialogTitle>
      <DialogContent>{currentStep.content({ shouldHideDialog, setShouldHideDialog })}</DialogContent>
      <DialogActions>
        <Box sx={{ display: 'flex', gap: 2, ml: 'auto' }}>
          {!isFirstStep && <Button onClick={() => handleStepChange(STEP.PREV)}>戻る</Button>}
          {isLastStep ? (
            <Button variant="contained" onClick={() => handleUnderstand()}>
              確認しました
            </Button>
          ) : (
            <Button variant="contained" onClick={() => handleStepChange(STEP.NEXT)}>
              次へ
            </Button>
          )}
        </Box>
      </DialogActions>
    </Dialog>
  )
}
